"use client"

import { Icon } from "@chakra-ui/react"
import { HStack } from "@chakra-ui/react/stack"
import { DotFillIcon } from "@/components/icons"

interface AccordionEducationTimelineProps {
  index: number
  isLastItem: boolean
}

const AccordionEducationTimeline = ({
  index,
  isLastItem,
}: AccordionEducationTimelineProps) => {
  return (
    <HStack
      _before={{
        bgColor: "border.emphasized",
        content: '""',
        height: !isLastItem ? "calc(100% + 16px)" : "50px",
        left: "50%",
        position: "absolute",
        top: index === 0 ? "-16px" : "-8px",
        transform: "translateX(-50%)",
        width: "1px",
        zIndex: 0,
      }}
      className="collumn2"
      flexShrink={0}
      maxWidth="10px"
      minWidth="10px"
      position={"relative"}
      width="10px"
    >
      <Icon
        as={DotFillIcon}
        color="primary.500"
        left={"50%"}
        position={"absolute"}
        top={"40px"}
        transform="translateX(-50%)"
      />
    </HStack>
  )
}

export default AccordionEducationTimeline
